import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["date", "startTime", "endTime"]

  updateEndTime() {
    const start = this.startTimeTarget.value
    if (!start) return

    const [hours, minutes] = start.split(":").map(Number)
    const endHours = (hours + 1) % 24
    this.endTimeTarget.value = `${String(endHours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`
  }
}
